<template>
  <button 
    class="navbar-toggler" 
    :class="{ 'scrolled': isScrolled }"
    type="button" 
    :aria-expanded="isOpen"
    aria-label="Toggle navigation"
    @click="$emit('toggle')"
  >
    <span class="hamburger" :class="{ 'open': isOpen }">
      <span class="hamburger-line"></span>
      <span class="hamburger-line"></span>
      <span class="hamburger-line"></span>
    </span>
  </button>
</template>

<script>
export default {
  name: 'NavToggle',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    isScrolled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle']
}
</script>

<style scoped>
.navbar-toggler {
  border: none;
  background: transparent;
  padding: 0.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  position: relative;
  transition: all 0.3s ease;
}

/* Nascondi su desktop */
@media (min-width: 992px) {
  .navbar-toggler {
    display: none !important;
  }
}

.navbar-toggler:focus {
  outline: 2px solid rgba(255, 255, 255, 0.5);
  outline-offset: 2px;
  border-radius: 4px;
}

.hamburger {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 24px;
  height: 18px;
  position: relative;
}

.hamburger-line {
  display: block;
  height: 2px;
  width: 100%;
  background-color: white;
  border-radius: 2px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: center;
}

.hamburger.open .hamburger-line:nth-child(1) {
  transform: translateY(8px) rotate(45deg);
}

.hamburger.open .hamburger-line:nth-child(2) {
  opacity: 0;
  transform: scaleX(0);
}

.hamburger.open .hamburger-line:nth-child(3) {
  transform: translateY(-8px) rotate(-45deg);
}

/* Quando non è scrolled, cambia colore */
.navbar-toggler:not(.scrolled) .hamburger-line {
  background-color: #2a5298;
}
</style>

